module.exports = __webpack_public_path__ + "static/media/footsteps.886b2063.svg";